import { z } from 'zod';

export const PriorityCustomerApiConnectionBodySchema = z.object({
  username: z.string(),
  password: z.string(),
});

// `priority_customer_api_connection` carries the connection timestamp, in the
// backend's own `YYYY-MM-DD HH:mm:ss.SSSSSS` shape rather than ISO 8601.
export const PriorityCustomerApiConnectionSaveResponseSchema = z.object({
  message: z.string(),
  priority_customer_api_connection: z.string(),
});
